import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import AppContext from '../../../context';
import s from './Audio.scss';
import messages from '../lessonDetailsMessages';
import intlPropTypes from '../../../constants/intlPropTypes';
var Audio = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson
  };
}), _dec(_class = injectIntl(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Audio, _React$Component);
  var _super = _createSuper(Audio);
  function Audio() {
    var _this;
    _classCallCheck(this, Audio);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onAudioTimeUpdate", function (_ref) {
      var _ref$target = _ref.target,
        currentTime = _ref$target.currentTime,
        duration = _ref$target.duration;
      var _this$props = _this.props,
        lesson = _this$props.lesson,
        complete = _this$props.complete;
      var position = currentTime / duration;
      if (position > 0.9 && !lesson.isCompleted) {
        Promise.resolve(complete())["catch"](function (error) {
          return console.error(error);
        });
      }
      if (position < 0.99) {
        _this.props.setAudioEnded(false);
      }
      if (position === 1) {
        _this.props.setAudioEnded(true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onEnded", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, complete, goToNextLesson, lesson, isCompleted;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props2 = _this.props, complete = _this$props2.complete, goToNextLesson = _this$props2.goToNextLesson, lesson = _this$props2.lesson;
            _context.prev = 1;
            if (lesson.isCompleted) {
              _context.next = 8;
              break;
            }
            _context.next = 5;
            return complete();
          case 5:
            isCompleted = _context.sent;
            if (isCompleted) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            goToNextLesson();
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      _this.props.setPlayPodcastAudio(true);
    });
    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      _this.props.setPlayPodcastAudio(false);
    });
    return _this;
  }
  _createClass(Audio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.play) {
        var player = document.getElementById('lessonAudio');
        _.invoke(player, 'play');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!_.get(prevProps, 'play') && _.get(this, 'props.play')) {
        var player = document.getElementById('lessonAudio');
        _.invoke(player, 'play');
      }
      if (_.get(prevProps, 'play') && !_.get(this, 'props.play')) {
        var _player = document.getElementById('lessonAudio');
        _.invoke(_player, 'pause');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
        _this2 = this;
      var _this$props3 = this.props,
        lesson = _this$props3.lesson,
        podcastAudioContentClass = _this$props3.podcastAudioContentClass;
      return /*#__PURE__*/_jsx("div", {
        className: classNames((_classNames = {}, _defineProperty(_classNames, s.lessonAudioContent, !podcastAudioContentClass), _defineProperty(_classNames, podcastAudioContentClass, podcastAudioContentClass), _classNames))
      }, _.get(lesson, '_id'), /*#__PURE__*/_jsx("audio", {
        // eslint-disable-line jsx-a11y/media-has-caption
        controlsList: "nodownload",
        id: "lessonAudio",
        onTimeUpdate: this.onAudioTimeUpdate,
        onEnded: this.onEnded,
        onPlay: this.onPlay,
        onPause: this.onPause,
        controls: true
      }, void 0, _.map(lesson.audios, function (_ref3) {
        var _id = _ref3._id,
          _ref3$file = _ref3.file,
          path = _ref3$file.path,
          mimetype = _ref3$file.mimetype;
        return /*#__PURE__*/_jsx("source", {
          src: "".concat(_this2.context.cloudfrontUrl, "/").concat(path),
          type: mimetype
        }, _id);
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.browserDoesntSupportAudioMsg)));
    }
  }]);
  return Audio;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  podcastAudioContentClass: '',
  play: false,
  goToNextLesson: _.noop,
  setPlayPodcastAudio: _.noop,
  setAudioEnded: _.noop
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class);
export { Audio as default };